import { Coastguard } from "@cofano/coastguard2-frontend-client";

export const coastguardInstance = new Coastguard({
	backendWebsocketHost: process.env.NODE_ENV === "development" ? "ws://localhost:1708" : "wss://" + window.location.hostname,
	redirectPath: "/view/authorize",
});
